import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/fms/fms_drivers`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function listActiveByLocation(location) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_drivers?filter[active-location]=${location}`, options)
    .then(response => {
     
      let driver = jsona.deserialize(response.data);
      delete driver.links;
      return driver;
    });
}
 
function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_drivers/${id}`, options)
    .then(response => {
      let driver = jsona.deserialize(response.data);
      delete driver.links;
      return driver;
    });
}

function add(drivers) {
  
  console.log(drivers);
  const payload = jsona.serialize({
    stuff: drivers,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/fms/fms_drivers`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(driver) {
  const payload = jsona.serialize({
    stuff: driver,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };
 
  return axios.patch(`${url}/fms/fms_drivers/${driver.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/fms/fms_drivers/${id}`, options);
}

function last_no() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_drivers/last/no`, options)
    .then(response => {
      return response.data;
    });
}

function bill_payment(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_drivers/bill_payment/${id}`, options)
    .then(response => {
      return response.data;
    });
}

function LisOutstanding() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/fms/fms_drivers/payable/list`, options)
    .then(response => {
      return response.data;
    });
}

function update_status(drivers) {
  const payload = jsona.serialize({
    stuff: drivers,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/fms/fms_drivers/update_status/${drivers.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}


export default {
  list,
  get,
  add,
  update,
  destroy,
  last_no,
  update_status,
  listActiveByLocation,
  bill_payment,
  LisOutstanding
};

